<template>
  <div
    class="folder_card"
    v-for="(item, index) in myArray"
    :key="index"
    :class="[
      item._id + '-cardFiles',
      { 'active-dropdown': activeDropdownId === item._id },
    ]"
  >
    <div class="card-body newfilesection" @contextmenu="onContextMenu($event, item)">
      <div class="d-flex">
        <div class="icon-small" v-if="item.type === 'pdf'">
          <Pdf />
        </div>
        <div class="icon-small" v-else-if="item.type === 'mp4'">
          <Mp4Svg />
        </div>
        <div class="icon-small" v-else-if="item.type === 'xlsx' || item.type === 'xls'">
          <Xls />
        </div>
        <div class="icon-small" v-else-if="item.type === 'zip'">
          <Zip />
        </div>
        <div class="icon-small" v-else-if="item.type === 'csv'">
          <Csv />
        </div>
        <div class="icon-small" v-else-if="item.type === 'txt'">
          <Txt />
        </div>
        <div class="icon-small" v-else-if="item.type === 'doc'">
          <Doc />
        </div>
        <div class="icon-small" v-else-if="item.type === 'mp3'">
          <Mp3Svg />
        </div>
        <div class="icon-small" v-else>
          <FileSvg />
        </div>
        <h5 class="m-0">{{ item.key }}</h5>
        <div class="card-header-toolbar">
          <div class="dropdown" :id="'dropdown-file-' + item._id">
            <span
              class="dropdown-toggle"
              :id="item._id + '-dropdownMenuButton'"
              data-toggle="dropdown"
            >
              <ThreeDotsSvg />
            </span>
            <div
              class="dropdown-menu dropdown-menu-right"
              :aria-labelledby="item._id + '-dropdownMenuButton'"
              v-if="isMain == 'trash'"
            >
              <a class="dropdown-item" @click.prevent="restoreFile(item.fullKey)">
                <RestoreSvg />
                <span>Restore</span>
              </a>
              <a
                class="dropdown-item bg-danger-light"
                @click.prevent="deleteForever(item.fullKey)"
                :class="[$store.state.user.userInfo.role_name === 'user' ? 'd-none' : '']"
              >
                <DeleteForeverSvg />
                <span>Delete Forever</span>
              </a>
            </div>
            <div
              class="dropdown-menu dropdown-menu-right"
              :aria-labelledby="item._id + '-dropdownMenuButton'"
              v-else
            >
              <a
                class="dropdown-item"
                @click.prevent="downloadFile(filePath(item.fullKey))"
              >
                <DownloadSvg />
                <span>Download</span>
              </a>
              <a
                class="dropdown-item"
                href="javascript:;"
                v-if="isMain != 'sharedWithMe'"
                @click="editFileName(item.key, item._id)"
              >
                <RenameSvg />
                <span>Rename</span>
              </a>
              <a
                class="dropdown-item"
                href="javascript:;"
                @click="shareFileName(item._id, item.key)"
              >
                <ShareSvg />
                <span>Share</span>
              </a>
              <a
                class="dropdown-item"
                href="javascript:;"
                v-if="isMain != 'sharedWithMe'"
                @click="moveFile(item._id, item.key, item.fullKey)"
              >
                <MoveSvg />
                <span>Move</span>
              </a>
              <a
                class="dropdown-item"
                href="javascript:;"
                @click="starredFolderFile(item._id, item.user_id)"
                v-if="item.starred == '0'"
              >
                <AddToStarredSvg />
                <span>Add to starred</span>
              </a>
              <a
                class="dropdown-item"
                href="javascript:;"
                @click="starredFolderFile(item._id, item.user_id)"
                v-else
              >
                <RemoveToStarredSvg />
                <span>Remove to starred</span>
              </a>
              <a
                class="dropdown-item"
                @click.prevent="deleteFile(item.fullKey)"
                v-if="isMain != 'sharedWithMe'"
              >
                <MoveToTrashSvg />
                <span>Move to Trash</span>
              </a>
              <a
                class="dropdown-item"
                @click.prevent="deletePermissionFile(item._id)"
                v-if="isMain == 'sharedWithMe'"
              >
                <MoveToTrashSvg />
                <span>Remove</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="newfilesection_image">
        <a
          :key="'img-' + index"
          :href="filePath(item.fullKey)"
          data-fancybox="gallery"
          :data-caption="item.key"
          class="image-thumb"
          v-if="item.type === 'pdf'"
        >
          <div class="mb-4 text-center p-3 rounded iq-thumb">
            <span>
              <Pdf />
            </span>
          </div>
        </a>
        <a
          href="javascript:;"
          class="image-thumb"
          v-else-if="item.type === 'xlsx' || item.type === 'xls'"
          @click.prevent="downloadFile(filePath(item.fullKey))"
        >
          <div class="mb-4 text-center p-3 rounded iq-thumb">
            <span>
              <Xls />
            </span>
          </div>
        </a>
        <a
          href="javascript:;"
          class="image-thumb"
          v-else-if="item.type === 'zip'"
          @click.prevent="downloadFile(filePath(item.fullKey))"
        >
          <div class="mb-4 text-center p-3 rounded iq-thumb">
            <span>
              <Zip />
            </span>
          </div>
        </a>
        <a
          href="javascript:;"
          class="image-thumb"
          v-else-if="item.type === 'csv'"
          @click.prevent="downloadFile(filePath(item.fullKey))"
        >
          <div class="mb-4 text-center p-3 rounded iq-thumb">
            <span>
              <Csv />
            </span>
          </div>
        </a>
        <a
          href="javascript:;"
          class="image-thumb"
          v-else-if="item.type === 'txt'"
          @click.prevent="downloadFile(filePath(item.fullKey))"
        >
          <div class="mb-4 text-center p-3 rounded iq-thumb">
            <span>
              <Txt />
            </span>
          </div>
        </a>
        <a
          href="javascript:;"
          class="image-thumb"
          v-else-if="item.type === 'doc'"
          @click.prevent="downloadFile(filePath(item.fullKey))"
        >
          <div class="mb-4 text-center p-3 rounded iq-thumb">
            <span>
              <Doc />
            </span>
          </div>
        </a>
        <a
          :key="'mp3-' + item"
          data-fancybox="gallery"
          :data-src="'#audio-player-' + item"
          data-type="inline"
          href="javascript:;"
          class="image-thumb"
          v-else-if="item.type === 'mp3'"
        >
          <div class="mb-4 text-center p-3 rounded iq-thumb">
            <span>
              <Mp3Svg />
            </span>
          </div>
        </a>
        <!-- <a :key="'video-' + item" :href="filePath(item.fullKey)" data-fancybox="gallery" class="image-thumb" v-else-if="item.type === 'mp4'">
                    <div class="mb-4 text-center p-3 rounded iq-thumb">
                        <span>
                            <video
                                :src="filePath(item.fullKey)"
                                width="200"
                                height="120"
                                muted
                                preload="metadata"
                                style="border-radius: 8px; pointer-events: none"
                            ></video>
                        </span>
                    </div>
                </a> -->
        <a
          :key="'video-' + item"
          :href="filePath(item.fullKey)"
          data-fancybox="gallery"
          class="image-thumb"
          v-else-if="item.type === 'mov' || item.type === 'mp4'"
        >
          <div class="mb-4 text-center p-3 rounded iq-thumb">
            <!-- shimmer overlay -->
            <div
              v-if="!loadedVideos[item._id]"
              class="shimmer"
              style="
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
              "
            ></div>

            <span>
              <video
                :src="filePath(item.fullKey)"
                width="200"
                height="120"
                muted
                preload="metadata"
                style="border-radius: 8px; pointer-events: none"
                @loadeddata="handleLoaded(item._id)"
              ></video>
            </span>
          </div>
        </a>
        <a
          :key="'img-' + item"
          :href="filePath(item.fullKey)"
          data-fancybox="gallery"
          class="image-thumb"
          :data-caption="item.key"
          :data-download-src="filePath(item.fullKey)"
          v-else
        >
          <div class="mb-4 text-center p-3 rounded iq-thumb">
            <span>
              <img :src="filePath(item.fullKey)" :alt="item.key" class="img-fluid" />
            </span>
          </div>
        </a>

        <div style="display: none" :id="'audio-player-' + item" if="item.type === 'mp3'">
          <div style="padding: 1rem; width: 300px">
            <audio controls style="width: 100%">
              <source :src="filePath(item.fullKey)" type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ShimmerFile v-if="$store.state.home.isHomeImgLoadingMore == true" />
  <vue-easy-lightbox
    :visible="visibleRef"
    :imgs="imgsRef"
    :index="indexRef"
    @hide="onHide"
  ></vue-easy-lightbox>

  <PdfViewer ref="PdfViewerRef" />
  <RenameFile ref="fileModalRef" />
  <ShareFile ref="fileShareModalRef" />
  <MoveFile ref="moveFileModalRef" />

  <input type="hidden" id="fileName" v-model="fileNamePath" />
  <a
    href="javascript:;"
    data-toggle="modal"
    data-target="#fileDeleteModals"
    class="d-none"
    id="fileDeleteTag"
    >delete</a
  >
  <div
    class="modal fade"
    id="fileDeleteModals"
    tabindex="-1"
    style="display: none"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="staticBackdropLabel"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Move to trash?</h5>
        </div>
        <div class="modal-body">
          <div class="col-12 text-center">
            <label for="bankName" class="form-label mb-0"
              >This File will be deleted from the drive.</label
            >
            <!-- <label for="bankName" class="form-label mb-0">This File will be deleted from the drive. It will
                            be in Recently Deleted for 30 days.</label> -->
          </div>
        </div>
        <div class="modal-footer">
          <button
            variant="success"
            class="btn btn-primary"
            v-on:click="deleteFinal()"
            v-if="isDeleteFlag == 1"
          >
            Delete File
          </button>
          <button variant="success" class="btn btn-primary" v-else>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
          <button
            variant="outline-primary"
            class="btn btn-secondary"
            id="closeTrashBtn"
            data-dismiss="modal"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
  <a
    href="javascript:;"
    data-toggle="modal"
    data-target="#foreverDeleteModals"
    class="d-none"
    id="foreverDeleteTag"
    >delete</a
  >
  <div
    class="modal fade"
    id="foreverDeleteModals"
    tabindex="-1"
    style="display: none"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="staticBackdropLabel"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Delete forever?</h5>
        </div>
        <div class="modal-body">
          <div class="col-12 text-center">
            <label for="bankName" class="form-label mb-0"
              >This File will be deleted forever.</label
            >
          </div>
        </div>
        <div class="modal-footer">
          <button
            variant="success"
            class="btn btn-primary"
            v-on:click="deleteForeverFinal()"
            v-if="isDeleteFlag == 1"
          >
            Delete File
          </button>
          <button variant="success" class="btn btn-primary" v-else>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
          <button
            variant="outline-primary"
            class="btn btn-secondary"
            id="closeTrashForeverBtn"
            data-dismiss="modal"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
  <context-menu v-model:show="show" :options="optionsComponent">
    <template v-if="activeItem">
      <!-- If in Trash -->
      <template v-if="isMain === 'trash'">
        <context-menu-item @click="restoreFile(activeItem.fullKey)">
          <RestoreSvg />
          <span>Restore</span>
        </context-menu-item>
        <context-menu-item @click="deleteForever(activeItem.fullKey)">
          <DeleteForeverSvg />
          <span>Delete Forever</span>
        </context-menu-item>
      </template>

      <!-- Normal File Context Menu -->
      <template v-else>
        <context-menu-item @click="downloadFile(filePath(activeItem.fullKey))">
          <DownloadSvg />
          <span>Download</span>
        </context-menu-item>

        <context-menu-item
          v-if="isMain !== 'sharedWithMe'"
          @click="editFileName(activeItem.key, activeItem._id)"
        >
          <RenameSvg />
          <span>Rename</span>
        </context-menu-item>

        <context-menu-item @click="shareFileName(activeItem._id, activeItem.key)">
          <ShareSvg />
          <span>Share</span>
        </context-menu-item>

        <context-menu-item
          v-if="isMain !== 'sharedWithMe'"
          @click="moveFile(activeItem._id, activeItem.key, activeItem.fullKey)"
        >
          <MoveSvg />
          <span>Move</span>
        </context-menu-item>

        <context-menu-item
          @click="starredFolderFile(activeItem._id, activeItem.user_id)"
          v-if="activeItem.starred === '0'"
        >
          <AddToStarredSvg />
          <span>Add to starred</span>
        </context-menu-item>

        <context-menu-item
          @click="starredFolderFile(activeItem._id, activeItem.user_id)"
          v-else
        >
          <RemoveToStarredSvg />
          <span>Remove from starred</span>
        </context-menu-item>

        <context-menu-item
          v-if="isMain !== 'sharedWithMe'"
          @click="deleteFile(activeItem.fullKey)"
        >
          <MoveToTrashSvg />
          <span>Move to Trash</span>
        </context-menu-item>

        <context-menu-item
          v-if="isMain === 'sharedWithMe'"
          @click="deletePermissionFile(activeItem._id)"
        >
          <MoveToTrashSvg />
          <span>Remove</span>
        </context-menu-item>
      </template>
    </template>
  </context-menu>
</template>

<script>
import RenameFile from "./RenameFile.vue";
import ShareFile from "./ShareFile.vue";
import MoveFile from "./MoveFile.vue";
import PdfViewer from "./PdfViewer.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import Csv from "../Widgets/Icon/Csv.vue";
import Doc from "../Widgets/Icon/Doc.vue";
import Zip from "../Widgets/Icon/Zip.vue";
import Txt from "../Widgets/Icon/Txt.vue";
import Xls from "../Widgets/Icon/Xls.vue";
import Pdf from "../Widgets/Icon/Pdf.vue";
import FileSvg from "@/components/Widgets/Icon/File.vue";
import DownloadSvg from "@/components/Widgets/Icon/Download.vue";
import RenameSvg from "@/components/Widgets/Icon/Rename.vue";
import MoveSvg from "@/components/Widgets/Icon/Move.vue";
import ShareSvg from "@/components/Widgets/Icon/Share.vue";
import AddToStarredSvg from "@/components/Widgets/Icon/AddToStarred.vue";
import RemoveToStarredSvg from "@/components/Widgets/Icon/RemoveToStarred.vue";
import MoveToTrashSvg from "@/components/Widgets/Icon/MoveToTrash.vue";
import ThreeDotsSvg from "@/components/Widgets/Icon/ThreeDots.vue";
import DeleteForeverSvg from "@/components/Widgets/Icon/DeleteForever.vue";
import RestoreSvg from "@/components/Widgets/Icon/Restore.vue";
import Mp3Svg from "@/components/Widgets/Icon/Mp3.vue";
import Mp4Svg from "@/components/Widgets/Icon/Mp4.vue";
import ShimmerFile from "./ShimmerFile.vue";
import $ from "jquery";
import { ContextMenu, ContextMenuItem } from "@imengyu/vue3-context-menu";
import { ref } from "vue";
import { postCommon } from "../../utils/api.js";
import { downloadFile, encodeBase62 } from "../../utils/helper.js";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
export default {
  name: "FileNamePage",
  components: {
    VueEasyLightbox,
    PdfViewer,
    MoveFile,
    Csv,
    Zip,
    Doc,
    Txt,
    Pdf,
    Xls,
    FileSvg,
    DownloadSvg,
    RenameSvg,
    MoveSvg,
    ShareSvg,
    AddToStarredSvg,
    RemoveToStarredSvg,
    MoveToTrashSvg,
    ThreeDotsSvg,
    DeleteForeverSvg,
    RestoreSvg,
    Mp3Svg,
    Mp4Svg,
    RenameFile,
    ShareFile,
    ShimmerFile,
    ContextMenu,
    ContextMenuItem,
  },
  data() {
    return {
      fileNamePath: "",
      activeDropdownId: null,
      activeItem: null,
      show: false,
      loadedVideos: {},
      isDeleteFlag: 1,
      optionsComponent: {
        iconFontClass: "iconfont",
        customClass: "class-a",
        zIndex: 3,
        minWidth: 230,
        x: 500,
        y: 200,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.myArray.forEach((item) => {
        const id = "#dropdown-file-" + item._id;
        const el = document.querySelector(id);

        if (el) {
          $(el).on("show.bs.dropdown", () => {
            this.activeDropdownId = item._id;
          });

          $(el).on("hide.bs.dropdown", () => {
            this.activeDropdownId = null;
          });
        }
      });
    });
    Fancybox.bind('[data-fancybox="gallery"]', {
      // Toolbar: true,
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: [],
          right: ["slideshow", "download", "thumbs", "close"],
        },
      },
      Thumbs: false,
      download: {
        // 👇 Set the actual file URL to download
        downloadSrc: (fancybox, slide) => {
          return slide.src;
        },
      },
      on: {
        close: (fancybox) => {
          const container = fancybox?.container;
          if (!container) return;

          const audios = container.querySelectorAll("audio");
          audios.forEach((audio) => {
            audio.pause();
            audio.currentTime = 0;
          });
        },
      },
    });
  },
  props: {
    myArray: {
      type: Array,
      required: true,
    },
    isMain: {
      type: String,
      default: "",
    },
  },
  methods: {
    downloadFile,
    encodeBase62,
    handleLoaded(id) {
      this.loadedVideos[id] = true;
    },
    filePath(path) {
      if (this.isMain == "trash") {
        return process.env.VUE_APP_S3_URL + "trash/" + path;
      }
      return process.env.VUE_APP_S3_URL + path;
    },
    async createFileFromParent(pdf) {
      this.$refs.PdfViewerRef.openPdfViewer(pdf);
    },
    async restoreFile(fileName) {
      let _post = {};
      _post = {
        fileName: fileName,
      };
      const resp = await postCommon("files/restore-file", _post);
      if (resp.status == 200 && resp.data.status == "success") {
        this.$toast.success(resp.data.message);

        const updatedList = this.$store.state.trash.fileList.filter(
          (file) => file.fullKey !== fileName
        );

        // Use a Vuex mutation to set the updated list
        this.$store.commit("trash/setFileList", updatedList);

        // this.$store.state.home.reLoadFolder = Math.random();
        // this.$store.state.home.reLoadPathFolder = Math.random();
        this.$store.state.home.reLoadFilecomponent = Math.random();
        document.getElementById("closeTrashBtn").click();
      } else if (resp.status == 200 && resp.data.status == "failure") {
        this.errorMessage = resp.data.message;
      }
      this.formLoader = 1;
    },
    async deleteForever(file) {
      this.fileNamePath = file;
      document.getElementById("foreverDeleteTag").click();
    },
    async deleteForeverFinal() {
      let _post = {};
      this.isDeleteFlag = 2;
      _post = {
        fileName: this.fileNamePath,
      };
      const resp = await postCommon("files/forever-delete-file", _post);
      if (resp.status == 200 && resp.data.status == "success") {
        this.$toast.success(resp.data.message);
        const updatedList = this.$store.state.trash.fileList.filter(
          (file) => file.fullKey !== this.fileNamePath
        );

        // Use a Vuex mutation to set the updated list
        this.$store.commit("trash/setFileList", updatedList);

        // this.$store.state.home.reLoadFolder = Math.random();
        // this.$store.state.home.reLoadPathFolder = Math.random();
        this.$store.state.home.reLoadFilecomponent = Math.random();
        document.getElementById("closeTrashForeverBtn").click();
      } else if (resp.status == 200 && resp.data.status == "failure") {
        this.errorMessage = resp.data.message;
      }
      this.isDeleteFlag = 1;
      this.formLoader = 1;
    },
    async deleteFinal() {
      let _post = {};
      this.isDeleteFlag = 2;
      _post = {
        fileName: this.fileNamePath,
      };
      const resp = await postCommon("files/delete-file", _post);
      if (resp.status == 200 && resp.data.status == "success") {
        this.$toast.success(resp.data.message);

        // const updatedList = this.$store.state.home.fileList.filter(
        //     file => file.fullKey !== this.fileNamePath
        // );
        // const updatedStarredList = this.$store.starred.fileList.filter(
        //     file => file.fullKey !== this.fileNamePath
        // );

        // // Use a Vuex mutation to set the updated list
        // this.$store.commit('home/setFileList', updatedList);
        // this.$store.commit('starred/setFileList', updatedStarredList);

        // this.$store.state.home.reLoadFolder = Math.random();
        // this.$store.state.home.reLoadPathFolder = Math.random();
        this.$store.state.home.reLoadFilecomponent = Math.random();
        document.getElementById("closeTrashBtn").click();
      } else if (resp.status == 200 && resp.data.status == "failure") {
        this.errorMessage = resp.data.message;
      }
      this.isDeleteFlag = 1;
      this.formLoader = 1;
    },
    async deleteFile(file) {
      this.fileNamePath = file;
      document.getElementById("fileDeleteTag").click();
    },
    async deletePermissionFile(_id) {
      let _post = {};
      _post = {
        _id: _id,
      };
      const resp = await postCommon("files/delete-file-permission", _post);
      if (resp.status == 200 && resp.data.status == "success") {
        this.$toast.success(resp.data.message);
        this.$store.state.home.reLoadFilecomponent = Math.random();
      } else if (resp.status == 200 && resp.data.status == "failure") {
        this.errorMessage = resp.data.message;
      }
      this.formLoader = 1;
    },
    async starredFolderFile(name, user_id) {
      let _post = {};
      _post = {
        _id: name,
        user_id: user_id,
      };
      const resp = await postCommon("starred/add-to-starred", _post);
      if (resp.status == 200 && resp.data.status == "success") {
        this.$toast.success(resp.data.message);
        // this.$store.state.home.reLoadPathFolder = Math.random();
        this.$store.state.home.reLoadFileHomeStarredComponent = Math.random();
      } else if (resp.status == 200 && resp.data.status == "failure") {
        this.errorMessage = resp.data.message;
      }
      this.formLoader = 1;
    },
    editFileName(name, _id) {
      const folderName = this.removeExtension(name);
      this.$refs.fileModalRef.renameFile(folderName, _id);
    },
    shareFileName(_id, name) {
      this.$refs.fileShareModalRef.shareFileModal(_id, name);
    },
    moveFile(_id, name, fullKey) {
      this.$refs.moveFileModalRef.openMoveFile(_id, name, fullKey);
    },
    removeExtension(filename) {
      return filename.replace(/\.[^/.]+$/, "");
    },
    onContextMenu(e, item) {
      e.preventDefault();

      $(".dropdown-menu").removeClass("show"); // manually close any Bootstrap dropdown
      $(".dropdown-toggle").dropdown("hide"); // in case it's toggled

      // this.activeDropdownId = item._id;

      //Set the mouse position
      this.optionsComponent.x = e.x;
      this.optionsComponent.y = e.y;
      this.activeItem = item;
      //Show menu
      this.show = true;
    },
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        this.activeDropdownId = null;
      }
    },
  },
  setup() {
    const visibleRef = ref(false);
    const indexRef = ref(0);
    const imgsRef = ref([]);
    const onShow = () => {
      visibleRef.value = true;
    };
    const showSingle = (itemCmt) => {
      imgsRef.value = [
        { title: "", src: itemCmt },
        // { title: itemCmt.file_name, src: itemCmt.file_url },
      ];
      onShow();
    };
    const onHide = () => (visibleRef.value = false);
    return {
      visibleRef,
      indexRef,
      imgsRef,
      showSingle,
      onHide,
    };
  },
};
</script>
<style scoped>
.shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
